
import React from 'react';

export default function AchievementsSection() {
  const mediaLogos = [
    { name: 'NHK山口', image: 'https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/7565fff7f3684e25acc35f0cc18c7a37.jfif' },
    { name: '山口新聞', image: 'https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/fb807f68872fa37f59c76b2c7de77a8a.jfif' },
    { name: 'tysテレビ山口', image: 'https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/84945c2bc9b40c626ae24160efd374ae.jfif' },
    { name: 'KRY山口放送', image: 'https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/e341930437e84297585e5b0562be55f5.jfif' },
    { name: 'yab山口朝日放送', image: 'https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/ecb4e21ba75a60051241113a143d5d81.jfif' },
    { name: '日経トレンディ', image: 'https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/8ad45be856b110cfd369dbebe31218f9.jfif' }
  ];

  return (
    <section className="py-16 md:py-32 bg-[#F2F5F9] mb-16 md:mb-32">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-20">
          <p className="text-sm font-medium uppercase tracking-wider mb-6"
             style={{ color: 'rgb(11, 61, 145)' }}>
            ACHIEVEMENTS
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#111827] mb-8 md:mb-16 leading-relaxed">
            主要な実績
          </h2>
          <p className="text-lg md:text-xl text-gray-600 leading-loose">
            メディア掲載・出演実績をご紹介
          </p>
        </div>

        {/* メディアロゴ */}
        <div className="bg-white rounded-2xl p-6 md:p-12 shadow-sm">
          <h3 className="text-lg md:text-xl font-bold text-[#111827] mb-8 md:mb-10 text-center leading-relaxed">
            掲載・出演・出版実績
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {mediaLogos.map((logo, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-6 md:p-8 h-40 md:h-48 flex flex-col items-center justify-center border border-gray-100">
                {logo.image ? (
                  <>
                    <img
                      src={logo.image}
                      alt={logo.name}
                      className="max-w-full max-h-24 md:max-h-32 object-contain mb-3 md:mb-4"
                    />
                    <span className="text-sm md:text-base font-medium text-gray-600 text-center leading-relaxed">{logo.name}</span>
                  </>
                ) : (
                  <span className="text-lg md:text-xl font-medium text-gray-600 text-center leading-relaxed">{logo.name}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}